import React from 'react';
import { hydrate } from 'react-dom';
import createStore from 'store/create';
import initialize from 'utils/app/initialize';
import App from 'containers/App';
import { TrackingClient } from '@sparefoot/tracking-client/dist/TrackingClient';
import { ReactSegmentWrapper } from '@sparefoot/segment-react-wrapper';

const decodedState = window?.__PRELOADED_STATE__
	? JSON.parse(Buffer.from(window.__PRELOADED_STATE__, 'base64').toString())
	: null;

const store = createStore(decodedState, { rollbar: window.Rollbar });
initialize(store);

const { app, user } = store.getState();

TrackingClient.initialize(
	new ReactSegmentWrapper({
		writeKey: app.segmentWriteKey,
		visitId: user.visitId,
		environment: app.environment,
		siteId: app.id,
		host: app.baseUrl.replace(/^https?:\/\//i, ''),
		cdnURL: app.eventsCdnUrl,
		debug:
			process.env.NODE_ENV === 'development' &&
			process.env.RENDER_ENV === 'client',
		integrations: {
			'Segment.io': {
				apiHost: app.eventsApiUrl,
				protocol: 'https',
			},
		},
	}),
);
const render = (AppComponent) =>
	hydrate(
		<AppComponent store={store} />,
		document.getElementById('js-page-content'),
	);

render(App);

if (module.hot) {
	module.hot.accept(['./containers/App', './pages/Bundles'], () => {
		const NextApp =
			require('./containers/App').default; /* eslint-disable-line global-require, max-len */
		render(NextApp);
	});
}
